import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, MenuItem, FormControl, InputLabel, SelectChangeEvent } from '@mui/material';

const LanguageSwitcher: React.FC = () => {
    const { i18n, t } = useTranslation();

    const handleLanguageChange = (event: SelectChangeEvent<string>) => {
        const newLang = event.target.value;
        void i18n.changeLanguage(newLang);
        // For RTL support
        document.dir = newLang === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.lang = newLang;
    };

    return (
        <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>{t('language.select')}</InputLabel>
            <Select
                value={i18n.language}
                onChange={handleLanguageChange}
                label={t('language.select')}
            >
                <MenuItem value="en">{t('language.en')}</MenuItem>
                <MenuItem value="fr">{t('language.fr')}</MenuItem>
                <MenuItem value="ar">{t('language.ar')}</MenuItem>
            </Select>
        </FormControl>
    );
};

export default LanguageSwitcher; 